import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useStore } from "../../context/StoreContext";

export default function Privacy() {
  const { settings: s, hasAccess } = useStore();
  useEffect(() => {
    document.title = "Política de privacidade | EMAIA PERFUMES";
  }, []);
  return (
    <div className="mx-auto max-w-3xl px-5 py-16" data-testid="privacy-page">
      <p className="eyebrow mb-3">LGPD</p>
      <h1 className="font-serif text-4xl font-medium text-[#FAF6F0] sm:text-5xl">Política de privacidade</h1>
      <div className="gold-line my-10 w-40" />
      <p className="whitespace-pre-line leading-relaxed text-[#C9C4BA]">{s?.privacy_text}</p>
      {s?.contact_email && <p className="mt-6 text-sm text-[#A1A1AA]">Contato para questões de privacidade: {s.contact_email}</p>}
      {!hasAccess && <Link to="/" className="btn-outline-gold mt-10" data-testid="privacy-back">Voltar</Link>}
    </div>
  );
}
